module.exports = __webpack_public_path__ + "static/media/album-music.2873d10a.svg";